import { RoundedBorder } from "../../../../base/styles";
import clsx from "clsx";

export const SelectRoundedBorder = ({ title, value, className, onChange }:{
    title: string,
    value?: RoundedBorder,
    className?: string,
    onChange: (value?: RoundedBorder) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as RoundedBorder;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={RoundedBorder.Rounded}>Rounded</option>
                <option value={RoundedBorder.End}>End</option>
                <option value={RoundedBorder.Bottom}>Bottom</option>
                <option value={RoundedBorder.Start}>Start</option>
                <option value={RoundedBorder.Circle}>Circle</option>
                <option value={RoundedBorder.Pill}>Pill</option>
            </select>
        </div>
    )
}